
import React, { useState, useReducer, useEffect, useRef } from "react";
// import SuperSearch from '../../shared/SuperSearch/SuperSearch';
import { enumUtil } from "../../../utils/Enum";
import isNull from "../../../utils/NullChecking";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import Table from "../../Setup/Shared/Table";
import Loader from "../../shared/Loader/Loader";
// import '../../shared/SuperSearch/SuperSearch.module.css'
import GridColumnHeader from "../../Setup/Shared/GridColumnHeader"
import { useDispatch, useSelector } from "react-redux";
import format from 'date-fns/format';
import Menu from '@mui/material/Menu';
import { DateRangePicker } from 'react-date-range';
import CalendaRangeInput from "../../General/CalendarRangeInput";
import SearchHeader from '../../Setup/Shared/SearchHeader';
import { Autocomplete, TextField } from "@mui/material";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import AmountFormatter from "../../../utils/AmountFormatter";
import handleCopyText from "../../shared/CopyData";
import { connect } from "react-redux"
import useHandleOpenNewBrowserTab from "../../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import SuperSearchMultiple from "../../shared/SuperSearch/SuperSearchMultiple";
import SuperSearchMultipleClient from "../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import { MainBarActiveTabsAction } from "../../../actions/MainBarActiveTabsAction";
import usePagination from "../../../customhooks/usePagination";
import HandleSelectColumnName from "../../../utils/HandleSelectColumnName";
import HandleStatus from "../../shared/HandleStatus";
import { IconStatementSent } from "../../shared/IconsComponent/icons";


const WriteOffReport = (props) => {
  const { type, Settings } = { ...props };
  const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
  let ActiveReport = useSelector(state => state.Open_Report_Tab?.find((re) => re.active));
  let SidebarActive = useSelector(state => state.SidebarActiveTab);
  const API_URL_GENERAL = enumUtil.controller.General
  const API_URL_CLAIM = enumUtil.controller.Claim
  const API_Report = enumUtil.controller.Report
  const API_URL_Patient = enumUtil.controller.Patient
  let ReportsData = useSelector(state => state.GeneralReportReducer)
  let ClaimCheck = ReportsData.ClaimChecks
  const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
  const Search_Data = {
    // "DOSFrom": null,
    // "DOSTo": null,
    // "CheckNumber": "",
    "InsuranceID": "-1",
    "ProviderID": "-1",
    "LocationID": "-1",
    "PatientIDs": "-1",
    "ClaimID": "",
    "Type": "-1",
    "WriteOffGroupID": '',
    "DOSFrom": null,
    "DOSTo": null,
    "EntryDateFrom": null,
    "EntryDateTo": null,
    "WriteOffFrom": null,
    "WriteOffTo": null,
    "Peram": ClaimCheck ? "Claim" : "ServiceLine",
    "WriteOffType": '-1',
    "ProcedureCode": "",
  }
  const TypeDD = [

    { value: -1, display: "" },
    { value: 'Insurance', display: 'Insurance' },
    { value: 'Manual', display: 'Manual' },
  ]
  const WriteOffTpe = [
    { value: '-1', display: "" },
    { value: 'Primary WriteOff', display: 'Primary WriteOff' },
    { value: 'Secondary WriteOff', display: 'Secondary WriteOff' },
    { value: 'Patient WriteOff', display: 'Patient WriteOff' },
  ]
  const initialLoad = useRef(false);
  const [dateType, setDateType] = useState(undefined);
  const [copiedText, setCopiedText] = useState({});
  const [is, setIs] = useState(false);
  const [patientValue, setPateintValue] = useState([])
  const [PatientDD, setPatientDD] = useState([])
  let DropdownData = useSelector(state => state.GeneralDropDownsReducer);
  let searchFieldCurrComponentKey = useSelector(state => state.MainBarActiveTabsReducer?.['Reports']?.ActiveTabKey
  );
  let searchFieldData = useSelector(state => state.MainBarActiveTabsReducer?.['Reports']?.SearchField);
  const [writeOffPatientReportsData, setWriteOffPatientReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [searchParam, setSearchParam] = useState(Search_Data)
  const [searchValue, setSearchValue] = useState({
    PatientName: "",
  });
  const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);
  const [writeOffDropdwon, setwriteOffDropdwon] = useState([])

  const [patientBody, setPatientBody] = useState({
    "TableName": enumUtil.enumAPITableName.Patient,
    "SearchParam": '',
  });
  const [writeOffGroup, setWriteOffGroup] = useState('')
  const [writeOffType, setWriteOffType] = useState('')

  const [typee, setTypee] = useState('')
  const [check, setCheck] = useState(ClaimCheck ? "Claim" : "ServiceLine")

  const [totalcountSummary, settotalcountSummary] = useState()
  const [viewThisPage, setViewThisPage] = useState('true')
  const [allRecordSummary, setAllRecordSummary] = useState({})
  const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })



  ////////====GridColumnHeader=========//////////
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  //////////////////////////////////////////////

  // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
  // const [PageNo, setPageNo] = useState(1);
  // const [TotalPages, setTotalPages] = useState(0);
  const [totalCounts, setTotalCounts] = useState()
  const [initialInsurance, setinitialInsurance] = useState([])
  const [intialLocation, setintialLocation] = useState([])
  const [intialProvider, setintialProvider] = useState([])
  const [procedureDD, setProcedureDD] = useState([])
  const [selectedCPT, setselectedCPT] = useState('')

  // const handlePageClick = (page) => { setPageNo(page); }
  // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
  // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
  // const handleFingByCreteria = (e) => {
  //   setPerPage(e.target.value)
  //   setPageNo(1)
  // }
  // const handleSelectData = (data) => {
  //       setPerPage(data.value)
  //       setPageNo(1)
  //   }
  //   useEffect(() => {
  //     if (isNull(searchFieldData)) {
  //         LoadData(searchParam)
  //     }
  // }, [PerPage, PageNo])
  const [dateRange, setDateRange] = useState(null)
  const returnSelectedValues = (val, options) => {
    const selectedItems = !['-1', -1, '', null, undefined].includes(val) ? val.split(', ') : [];
    const data = options.filter(item => selectedItems.includes(String(item.value)));
    return data;
  }

  useEffect(() => {
    ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
      "TableName": enumUtil.enumAPITableName.Procedure
    })
      .then((response) => {
        setProcedureDD(response)
      }).catch((error) => {
        // setIsLoading(false)
      })
  }, []);
  useEffect(() => {
    handleClear()
    if (!isNull(searchFieldData)) {
      console.log(searchFieldData, 'searchFieldData');

      Object.keys(searchParam).forEach(key => searchParam[key] = Search_Data[key]);
      ////  for Calendar Date Range  ////
      if (searchFieldData.DateType && searchFieldCurrComponentKey === 4310) {

        setDateType(searchFieldData.DateType);
        dispatch(MainBarActiveTabsAction({ 'Reports': { ActiveTabKey: 4310, SearchField: undefined } }));
      } else {
        if (!isNull(searchFieldData.DOSFrom)) {
          setDateRange(`${searchFieldData.DOSFrom + '-' + searchFieldData.DOSTo}`)
          setDateType('DOS')
        } else if (!isNull(searchFieldData.EntryDateFrom)) {
          setDateRange(`${searchFieldData.EntryDateFrom + '-' + searchFieldData.EntryDateTo}`)
          setDateType('EntryDate')
        }
        if (searchFieldData?.PatientList) {
          setPateintValue(searchFieldData.PatientList);
        }
        const updatedSearchParam = {
          ...searchParam,
          PatientIDs: searchFieldData.PatientIDs ? String(searchFieldData.PatientIDs) : "",
          InsuranceID: searchFieldData.InsuranceID ? String(searchFieldData.InsuranceID) : "",
          LocationID: searchFieldData.LocationID ? String(searchFieldData.LocationID) : "",
          ProviderID: searchFieldData.ProviderID ? String(searchFieldData.ProviderID) : "",
          DOSFrom: searchFieldData.DOSFrom ? searchFieldData.DOSFrom : "",
          DOSTo: searchFieldData.DOSTo ? searchFieldData.DOSTo : "",
          EntryDateFrom: searchFieldData.EntryDateFrom ? searchFieldData.EntryDateFrom : "",
          EntryDateTo: searchFieldData.EntryDateTo ? searchFieldData.EntryDateTo : "",
        };
        if (searchFieldData && searchFieldData.InsuranceID) {
          const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.InsuranceID) ? searchFieldData.InsuranceID.split(', ') : [];
          const data = DropdownData.Insurance.filter(item => selectedItems.includes(String(item.value)));
          setinitialInsurance(data);
        }
        if (searchFieldData && searchFieldData.LocationID) {
          const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.LocationID) ? searchFieldData.LocationID.split(', ') : [];
          const data = DropdownData.Location.filter(item => selectedItems.includes(String(item.value)));
          setintialLocation(data);
        }
        if (searchFieldData && searchFieldData.ProviderID) {
          const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.ProviderID) ? searchFieldData.ProviderID.split(', ') : [];
          const data = DropdownData.Provider.filter(item => selectedItems.includes(String(item.value)));
          setintialProvider(data);
        }
        setReloadSuperSearchPatient(!reloadSuperSearchPatient);
        setSearchParam(updatedSearchParam);
        dispatch(MainBarActiveTabsAction({ 'Write Off': { ActiveTabKey: 4310, SearchField: searchFieldData } }));
        LoadData(updatedSearchParam);
      }
    }
  }, [searchFieldData]);
  useEffect(() => {
    // setIsLoading(true)
    ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
      "TableName": enumUtil.enumAPITableName.WriteOffGroup
    }).then((response) => {
      // setIsLoading(false)
      setwriteOffDropdwon(response)
    })
  }, [])
  useEffect(() => {
    setSearchParam({ ...searchParam, Peram: ClaimCheck ? "Claim" : "ServiceLine" })
    setWriteOffPatientReportData([])
  }, [ClaimCheck])

  const isEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
      if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  };
  const isFilterApplied = () => {
    return !isEqual(searchParam, Search_Data);
  };
  const LoadData = (searchParam) => {
    const newPageNo = (isEqual(searchParam, Search_Data) ? PageNo : 1);
    setWriteOffPatientReportData([])
    setIsLoading(true)
    ServerRequestProtected(API_Report + "/ReportList", 'post', {
      "TableName": enumUtil.enumAPITableName.WRITEOFFREPORT,
      "SEARCHCRITERIA": searchParam,
      "PerPage": PerPage,
      "PageNo": newPageNo,
    }).then((response) => {
      setIsLoading(false)
      // setGroupBy(searchParam.GroupBy)
      handleGridHeader({ defaultData: response.Rows })
      setWriteOffPatientReportData(response.Rows)
      setTotalPages(response.count.NumOfPages);
      setTotalCounts(response.Rows.length)
      settotalcountSummary(response.count)
      setAllRecordSummary(response?.TotalCount)

      // setCheck(response?.count?.DataField)
    }).catch((error) => {
      setIsLoading(false)
      setWriteOffPatientReportData('')
      setTotalCounts(0)
    })
  }
  const [writeoffNotesDD, setWriteOffNotesDD] = useState([])

  useEffect(() => {
    // setIsLoading(true)
    ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
      "TableName": enumUtil.enumAPITableName.WRITEOFFREPORT
    }).then((response) => {
      // setIsLoading(false)
      setWriteOffNotesDD(response)
    }).catch((error) => {
      // setIsLoading(false)
      // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
      // setIsLoading(false)
    })
  }, []);

  const handleCopy = (row, type) => {
    let name = `${row}-${type}`;
    handleCopyText(type);
    setCopiedText({ ...copiedText, [name]: true });
    setTimeout(() => {
      setCopiedText({ ...copiedText, [name]: false });
    }, 300)
  }

  const summaryRow = {

    TotalCheckAmount: viewThisPage === 'false' ? allRecordSummary?.AllCheckAmount : totalcountSummary?.TotalCheckAmount,
    TotalBilled: viewThisPage === 'false' ? allRecordSummary?.AllBilled : totalcountSummary?.TotalBilled,
    TotalAllowed: viewThisPage === 'false' ? allRecordSummary?.AllAllowed : totalcountSummary?.TotalAllowed,
    TotalPaid: viewThisPage === 'false' ? allRecordSummary?.AllPaid : totalcountSummary?.TotalPaid,
    ContAdj: viewThisPage === 'false' ? allRecordSummary?.AllContAdj : totalcountSummary?.ContAdj,
    ManualWriteOff: viewThisPage === 'false' ? allRecordSummary?.AllManualWriteOff : totalcountSummary?.ManualWriteOff,
    SecManualWriteOff: viewThisPage === 'false' ? allRecordSummary?.AllSecManualWriteOff : totalcountSummary?.SecManualWriteOff,
    PatManualWriteOff: viewThisPage === 'false' ? allRecordSummary?.AllPatManualWriteOff : totalcountSummary?.PatManualWriteOff,






  };
  const bottomSummaryRows = writeOffPatientReportsData?.length > 0 ? [summaryRow] : [];

  const columns = [
    {
      key: 'Insurance',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'Insurance'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      width: 250,
      resizable: true,
      renderCell: ({ row }) => {
        return (
          <>
            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
              <div className="copy_icon validation_message">
                {row.Insurance}
              </div>
              {row.Insurance && <div className="icon_copy">
                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Insurance)}></i>
                <p class="tool_tip xsm_text text-light">Copy</p>
              </div>}
              {copiedText[`${row.LineID}-${row.Insurance}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            </div>
          </>
        );
      },
      renderSummaryCell() {
        return (
          <div className="d-flex align-items-center gap-1 za_View">
            <p className='heading'>Total:</p>
            <div className="d-flex gap-2">
              <div className="ar_radio-btn d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="Write_status"
                  value="true"
                  checked={viewThisPage === 'true'}
                  onChange={(e) => setViewThisPage(e.target.value)}
                />
                <p for="Active" className="text fs-12 ar-orange-text" >This Page</p>
              </div>
              <div className="ar_radio-btn d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="Write_status"
                  value="false"
                  checked={viewThisPage === 'false'}
                  onChange={(e) => setViewThisPage(e.target.value)} />
                <p for="InActive" className="text fs-12 ar-orange-text" >All Pages</p>
              </div>
            </div>
          </div>
        )
      }

    },
    // {
    //   key: 'CheckAmount',
    //   name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //     iconName={'icon-card'} headerName={'Check Amount'} sortIcon={true} type={'number'} colKey={'CheckAmount'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
    //   renderCell: ({ row }) => { return (<><AmountFormatter amount={row.CheckAmount} /></>) },
    //   resizable: true,
    //   renderSummaryCell: () => {
    //     return (
    //       <AmountFormatter amount={summaryRow?.TotalCheckAmount} />)
    //   }
    // },
    // {
    //   key: 'CheckDate',
    //   name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //     iconName={'icon-card'} headerName={'Check Date'} sortIcon={true} type={'date'} colKey={'CheckDate'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
    //   resizable: true,
    // },
    // {
    //   key: 'Check#',
    //   name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //     iconName={'icon-card'} headerName={'Check #'} sortIcon={true} type={'number'} colKey={'Check#'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
    //   resizable: true,
    // },
    {
      key: 'Patient',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'Patient'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      width: 200,
      resizable: true,
      renderCell: ({ row }) => {
        return (
          <>
            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
              <div className="copy_icon validation_message">
                {row.Patient}
              </div>
              {row.Patient && <div className="icon_copy">
                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Patient)}></i>
                <p class="tool_tip xsm_text text-light">Copy</p>
              </div>}
              {copiedText[`${row.LineID}-${row.Patient}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            </div>
          </>
        );
      }
    },
    {

      key: 'Account#',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Account #'} sortIcon={true} type={'number'} colKey={'Account#'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
    },
    ...(DropdownData?.IsHomeCare === 'true' ? [
      {
        key: 'MedicaidNo',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Medicaid #'} sortIcon={true} type={'string'} colKey={'MedicaidNo'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
        resizable: true
      },
    ] : []),
    {
      key: 'ClaimID',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Claim #'} sortIcon={true} type={'number'} colKey={'ClaimID'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
      renderCell({ row }) {
        let data = {
          name: 'Claims',
          data: {
            id: row.ClaimID,
            name: row.Patient,
            VisitType: row.ClaimType,
            EncounterID: row?.EncounterID,
            PatientID: row?.PatientID,
          }
        };
        return (
          <>
            <div className='slim_link copy_icon' onClick={() => handleOpenNewBrowserTab(data)}>{row.ClaimID} </div>

          </>
        );
      },
    },
    ...(searchParam.Peram === 'ServiceLine' ? [
      {
        key: 'LineID',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Line ID'} sortIcon={true} type={'number'} colKey={'LineID'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
        resizable: true,
      },
    ] : []),
    {
      key: 'Status',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      // renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Accout} /></>) },
      resizable: true,
      width: 150,
      // renderCell: ({ row }) => {
      //   return <HandleStatus Status={row?.Status} RejectionReason={row?.MsgStatus} />
      //   // return HandleStatus(row.Status, row.MsgStatus)
      // },
      renderCell: ({ row }) => {

        return (<>
          <div className="d-flex align-items-center gap-10 justify-content-between w-100">
            <HandleStatus Status={row?.Status} RejectionReason={row?.MsgStatus} />
            {
              !isNull(row?.PrintStatementDate) &&
              <div className="app_tooltip bottom grossary description claimStatus">
                <IconStatementSent />
                <p className="tool_tip start-0">
                  <span className='text text-light  multi-line-truncate text-wrap overflow-hidden fs-12'>
                    Statement Sent By/Date: {row?.PrintStatementBy}, {row?.PrintStatementDate}
                  </span>
                </p>
              </div>
            }
          </div>
        </>)
      },
    },

    {
      key: 'DOS',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'DOS'} sortIcon={true} type={'date'} colKey={'DOS'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
    },
    {
      key: 'Units',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Units'} sortIcon={true} type={'number'} colKey={'Units'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
    },
    ...(searchParam.Peram === 'ServiceLine' ? [
      {
        key: 'CPT',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'CPT'} sortIcon={true} type={'string'} colKey={'CPT'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
        resizable: true,
      },
    ] : []),
    {
      key: 'Billed',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Billed'} sortIcon={true} type={'number'} colKey={'Billed'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Billed} /></>) },
      resizable: true,
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.TotalBilled} />)
      }
    },
    {
      key: 'Allowed',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Allowed'} sortIcon={true} type={'string'} colKey={'Allowed'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Allowed} /></>) },
      resizable: true,
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.TotalAllowed} />)
      }
    },
    {
      key: 'Paid',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Paid'} sortIcon={true} type={'string'} colKey={'Paid'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Paid} /></>) },
      resizable: true,
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.TotalPaid} />)
      }
    },
    {
      key: 'ContAdj',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Contr. Adj'} sortIcon={true} type={'string'} colKey={'ContAdj'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.ContAdj} /></>) },
      resizable: true,
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.ContAdj} />)
      }
    },
    {
      key: 'WriteOffGroup',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Write Off Group'} sortIcon={true} type={'string'} colKey={'WriteOffGroup'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
    },
    {
      key: 'ManualWriteOff',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Pri Writeoff'} sortIcon={true} type={'string'} colKey={'ManualWriteOff'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.ManualWriteOff} /></>) },
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.ManualWriteOff} />)
      }
    },
    {
      key: 'SecManualWriteOff',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Sec Writeoff'} sortIcon={true} type={'string'} colKey={'SecManualWriteOff'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.SecManualWriteOff} /></>) },
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.SecManualWriteOff} />)
      }
    },
    {
      key: 'PatManualWriteOff',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Pat Writeoff'} sortIcon={true} type={'string'} colKey={'PatManualWriteOff'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
      renderCell: ({ row }) => { return (<><AmountFormatter amount={row.PatManualWriteOff} /></>) },
      renderSummaryCell: () => {
        return (
          <AmountFormatter amount={summaryRow?.PatManualWriteOff} />)
      }
    },
    {
      key: 'WriteOffDate',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Writeoff Date'} sortIcon={true} type={'date'} colKey={'WriteOffDate'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
    },
    {
      key: 'WriteOffNotes',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-card'} headerName={'Write Notes'} sortIcon={true} type={'string'} colKey={'WriteOffNotes'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
      resizable: true,
      width: 200,
      renderCell: ({ row }) => {
        return (
          <div className="validation_message" title={row.WriteOffNotes}>{row.WriteOffNotes}</div>
        );
      },
    },

  ];
  const AllColumnsName = HandleSelectColumnName(columns);


  useEffect(() => {
    if (!initialLoad.current) {
      initialLoad.current = true;
      return;
    }
    if (isNull(searchFieldData)) {
      LoadData(searchParam);
    }
    handleGridHeader({ defaultData: writeOffPatientReportsData });
  }, [PerPage, PageNo]);

  ///// to set Dates in Calendar Range on navigation from dashboard
  useEffect(() => {
    if (dateType !== undefined && !dateType) {
      ////  dateType is set to empt after setting it , to make it work on subsequent visits
      console.log("LoadData")
      LoadData(searchParam);
    }
  }, [dateType])

  const rowClass = () => {
    return "row-bg";
  };


  const handleMUltiSelectedData = (selectedDataArray, type, name) => {
    // console.log("selectedDataArray")
    let modal = { ...searchParam };
    if (type === 'server' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);

      modal[name] = valueValues.join(', ');
      // PatientSaveUpdateModal[name] = valueValues.join(', ');
    } else if (type === 'client' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);
      modal[name] = valueValues.join(', ');

      // PatientSaveUpdateModal[name] = valueValues.join(', ');
    }
    else {
      console.log("selectedDataArray");
      modal[name] = '';
      // PatientSaveUpdateModal[name] = '';
    }
    setSearchParam(modal);
    // setPatientSaveUpdateModal(PatientSaveUpdateModal);
    return selectedDataArray;
  }
  const searchButton = {
    AddNew: false,
    Excel: true,
    PDF: true,
    Delete: false,
    Filter: false,
    View: false
  }
  const handleSelectedDataa = (selectedData, name, type) => {
    if (type === 'client' && !isNull(selectedData)) {
      if (name === 'WriteOffGroupID') {
        setSearchParam({ ...searchParam, WriteOffGroupID: selectedData.value + "", })
        setWriteOffGroup(selectedData.display)
      } else if (name === 'WriteOffType') {
        setSearchParam({ ...searchParam, WriteOffType: selectedData.value + "", })
        setWriteOffType(selectedData.display)
      }
      else if (name === 'WriteOffNotes') {
        setSearchParam({ ...searchParam, WriteOffNotes: selectedData.value + "", })
        setWriteOffNotesDisplay(selectedData.display)
      }

      if (name === 'Type') {
        setSearchParam({ ...searchParam, Type: selectedData.value + "", })
        setTypee(selectedData.display)
      }
      if (name === 'ProcedureCode') {
        setSearchParam({ ...searchParam, ProcedureCode: selectedData.value + "", })
        setselectedCPT(selectedData.display)
      }
    } else {
    }
    return selectedData
  }

  const handleSelectedData = (selectedData, name, type) => {
    if (type === 'server' && !isNull(selectedData)) {
      if (name === 'ProcedureCode') {
        setSearchParam({ ...searchParam, ProcedureCode: selectedData.display })
      }
    } else {
      setPateintValue('')
      setSearchParam({ ...searchParam, PatientIDs: '' })
      setSearchParam({ ...searchParam, ProcedureCode: '' })
    }
  }

  const handleCPTChange = (e) => {
    setIs(false)
    setSearchParam({ ...searchParam, ProcedureCode: e.target.value })
    setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": e.target.value })
  }
  const [WriteOffNotesDisplay, setWriteOffNotesDisplay] = useState()
  const handleChange = (e) => {
    let { name, value } = e.target
    if (name === 'WriteOffGroupID') {
      setWriteOffGroup(value)
    } else if (name === 'Type') {
      setTypee(value)
    } else if (name === 'WriteOffType') {
      setWriteOffType(value)
    } else if (name === 'WriteOffNotes') {
      setWriteOffNotesDisplay(value)
    }
    else if (name === 'ProcedureCode') {
      setselectedCPT(value)
    }
  }

  const handleClear = () => {
    setPateintValue([])
    setinitialInsurance([])
    setintialProvider([])
    setintialLocation([])
    setTypee('')
    setWriteOffGroup('')
    setWriteOffType('')
    setSearchParam(Search_Data)
    setReloadSuperSearchPatient(!reloadSuperSearchPatient);
    setWriteOffNotesDisplay('')
    setselectedCPT('')

  }
  return (
    <>
      <div className="container-fluid py-2">
        <div className='row align-items-end'>
          <div className="col-md-12 hk-opt-bar">
            <div className="row row-half row-gap-15 align-items-end">
              <div className="col-md-3 multipleSearch-rounded rounded-full agency-pat-search">
                <div className="input autocomplete-group autocomplete-group-xs">
                  <label htmlFor="">Patient</label>
                  <div className='input-group'>
                    <SuperSearchMultiple
                      key={reloadSuperSearchPatient}
                      type='server'
                      id="PatientIDs"
                      name="PatientIDs"
                      SuperSearchView="DetailedView"
                      DetailedView="Patient"
                      onSelect={handleMUltiSelectedData}    // use for get data 
                      initialSelectedValues={patientValue} // comment here the pupose of this , whoever made his
                      initialSelectedOptionsInstant={patientValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                      tableName={enumUtil.enumAPITableName.Patient} //send Tablename api
                      searchTerm={patientValue} //for search ipnut  // probably not getting used in this case //test it later
                      controller={API_URL_Patient}
                      ApiLink={"/InstantSearchWithDetails"} //api url 
                      method='post'  //   api method 
                      // postBody={checkBody}
                      // onChange={handleCheckNumberChange}
                      sup_btn='sup_btn-Inp'
                      sup_inp='superSearchVisitInp'
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3 multipleSearch-rounded">
                <div className="input">
                  <label>Insurance</label>
                  <SuperSearchMultipleClient
                    key={`${reloadSuperSearchPatient}-${initialInsurance}-${searchFieldData}`}
                    id="InsuranceID"
                    name="InsuranceID"
                    selectedOptionsDisplay='Insurance'
                    initialSelectedValues={initialInsurance}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>
              <div className="col-md-3 multipleSearch-rounded">
                <div className="input race">
                  <label >Location</label>
                  <SuperSearchMultipleClient
                    key={reloadSuperSearchPatient}
                    id="LocationID"
                    name="LocationID"
                    selectedOptionsDisplay='Location'
                    initialSelectedValues={intialLocation}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    options={DropdownData?.Location?.filter(item => !['-1', -1].includes(item.value))}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>
              <div className="col-md-3 multipleSearch-rounded">
                <div className="input race">
                  <label >Provider</label>
                  <SuperSearchMultipleClient
                    key={reloadSuperSearchPatient}
                    id="ProviderID"
                    name="ProviderID"
                    selectedOptionsDisplay='Provider'
                    initialSelectedValues={intialProvider}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    options={DropdownData?.Provider?.filter(item => !['-1', -1].includes(item.value))}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>

            </div>
          </div>
          <div className="col-md-12 hk-opt-bar">
            <div className="row row-half row-gap-15 align-items-end mt-1">

              <div className="col-md-3">
                {/* <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date', 'Deposit', 'Check',]} /> */}
                <CalendaRangeInput
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  options={['DOS', 'Entry Date', 'WriteOff']}
                  DateType={dateType}
                  SetDateType={setDateType}
                  defaultDates={dateRange} />
              </div>

              {/* <div className="col-md-2">
                <div className="input">
                  <label>Check #</label>
                  <input className='form-control fc-xs rounded'
                    name="CheckNumber"
                    id="CheckNumber"
                    value={searchParam.CheckNumber}
                    onChange={(e) => { setSearchParam({ ...searchParam, CheckNumber: e.target.value }) }}
                  />
                </div>
              </div> */}
              <div className="col-md-2 multipleSearch-rounded">
                <div className="input">
                  <label>Write Off Type</label>
                  {/* <SuperSearchList
                    type="client"
                    id='WriteOffType'
                    name='WriteOffType'
                    searchValue={writeOffType}
                    data={WriteOffTpe}
                    onChange={(e) => handleChange(e)}
                    getSelectedData={handleSelectedDataa}
                    is={is}
                    icon={'Simple'}
                    sup_btn='sup_btn'
                    sup_inp='superSearchVisitInp'
                    className="form-control rounded"
                  /> */}
                  <SuperSearchMultipleClient
                    key={reloadSuperSearchPatient}
                    id="WriteOffType"
                    name="WriteOffType"
                    selectedOptionsDisplay='WriteOffType'
                    initialSelectedValues={[]}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    // options={WriteOffTpe}
                     options={WriteOffTpe?.filter(item => !['-1', -1, ""].includes(item.value))}
                    // clear={clear}
                    // setClear={setClear}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>
              <div className="col-md-1">
                <div className="input">
                  <label>Claim #</label>
                  <input className='form-control fc-xs rounded'
                    name="ClaimID"
                    id="ClaimID"
                    value={searchParam.ClaimID}
                    onChange={(e) => { setSearchParam({ ...searchParam, ClaimID: e.target.value }) }}
                  />
                </div>
              </div>

              <div className="col-md-2 multipleSearch-rounded">
                <div className="input">
                  <label>Write Off Group </label>
                  {/* <SuperSearchList
                    type="client"
                    id='WriteOffGroupID'
                    name='WriteOffGroupID'
                    searchValue={writeOffGroup}
                    data={writeOffDropdwon}
                    onChange={(e) => handleChange(e)}
                    getSelectedData={handleSelectedDataa}
                    is={is}
                    icon={'Simple'}
                    sup_btn='sup_btn'
                    sup_inp='superSearchVisitInp'
                    className="form-control rounded"
                  /> */}
                  <SuperSearchMultipleClient
                    key={reloadSuperSearchPatient}
                    id="WriteOffGroupID"
                    name="WriteOffGroupID"
                    selectedOptionsDisplay='WriteOffGroup'
                    initialSelectedValues={[]}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    // options={writeOffDropdwon}
                     options={writeOffDropdwon?.filter(item => !['-1', -1, ""].includes(item.value))}

                    // clear={clear}
                    // setClear={setClear}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>
              <div className="col-md-3 d-flex">
                <div className='btns-group-flex'>
                  <button className='btn btn-orange btn-xs no-width rounded' onClick={() => LoadData(searchParam)}>Search</button>
                  <div className='line-border'></div>
                  <button className='btn btn-outline btn-xs no-width rounded' onClick={() => handleClear()}>Clear</button>
                </div>
              </div>
              <div className="col-md-1 ins-aging-record aging">
                <div className="d-flex justify-content-end gap-1 align-items-center">
                  <SearchHeader
                    searchButton={searchButton}
                    tableName={enumUtil.enumAPITableName.WRITEOFFREPORT}
                    Name={"Write Off"}
                    searchParam={{ ...searchParam, IsExcelExport: "1" }}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    Model={"report"}
                    isEmpty={writeOffPatientReportsData.length > 0}
                    componentColumns={AllColumnsName}
                    ColumnTableName={'WRITEOFFREPORT'}
                    enabled={ActiveReport?.data.id === 4310 && SidebarActive === 4}
                  />
                  <div className='line-border'></div>
                  <button className="btn-icon-transparent ">
                    <i className={`br-left-1 br-clr ps-1 ${isFilterApplied()
                      ? "icon-Icon-awesome-filter fs-16"
                      : "icon-filter1"
                      }`} onClick={() => setFilterShow(true)}></i>
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div className="position-relative">

        <div className={`sidebar-filters claims_filter top-100  ${filterShow && 'active'}`}>
          <div className="sidebar-filters__heading">
            <span>Filters</span>
            <button className="btn btn-transparent" onClick={() => setFilterShow(!filterShow)}>
              <i className="bi bi-x"></i>
            </button>
          </div>
          <hr />
          <div className="sidebar-filters__body overflow-visible">
            <div className="input filters-field multipleSearch-rounded">
              <div className="input">
                <label>Type</label>
                <SuperSearchList
                  type="client"
                  id='Type'
                  name='Type'
                  searchValue={typee}
                  data={TypeDD}
                  onChange={(e) => handleChange(e)}
                  getSelectedData={handleSelectedDataa}
                  is={is}
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                  className="form-control rounded"
                />
              </div>
            </div>
            {/* <div className="input filters-field">
              <div className="input autocomplete-group autocomplete-group-xs">
                <label>CPT</label>
                <SuperSearchList
                  type='server'
                  id='ProcedureCode'
                  name='ProcedureCode'
                  searchValue={searchParam.ProcedureCode}
                  ApiLink={API_URL_CLAIM + "/CPTInstantSearch"}
                  method='post'
                  postBody={cptBody}
                  onChange={(e) => handleCPTChange(e)}
                  getSelectedData={handleSelectedData}
                  is={is}
                  sup_btn='sup_btn-Inp'
                  sup_inp='superSearchVisitInp'
                  // disabled={true}
                  icon={true}
                  placeholder={"Search..."}
                />
              </div>
            </div> */}
            <div className="input filters-field multipleSearch-rounded">
              <div className="input">
                <label>CPT</label>
                <SuperSearchList
                  type="client"
                  id='ProcedureCode'
                  name='ProcedureCode'
                  searchValue={selectedCPT}
                  // data={procedureDD}
                  data={[
                    { display: '', value: '' },
                    ...(procedureDD || [])
                  ]}
                  onChange={(e) => handleChange(e)}
                  getSelectedData={handleSelectedDataa}
                  is={is}
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                />
              </div>
            </div>

            <div className="input filters-field multipleSearch-rounded">
              <div className="input">
                <label>Writeoff Notes</label>
                <SuperSearchList
                  type="client"
                  id='WriteOffNotes'
                  name='WriteOffNotes'
                  searchValue={WriteOffNotesDisplay}
                  data={writeoffNotesDD}
                  onChange={(e) => handleChange(e)}
                  getSelectedData={handleSelectedDataa}
                  is={is}
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                  className="form-control rounded"
                />
              </div>
            </div>
            <div className="sidebar-filters__footer">
              <button
                className="btn btn-orange"
                onClick={() => {
                  setFilterShow(false);
                  LoadData(searchParam);
                }}>Apply</button>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? <Loader /> : null}
      {show === false ? (
        <div className="table-view">
          <Table
            columns={columns}
            key={columns}
            rows={writeOffPatientReportsData}
            bottomSummaryRows={bottomSummaryRows}
            height="500px"
            rowClass={rowClass}
            // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
            // dynamicClass="fill-grid DataGrid-Table hk-exp-table  writeoff_report  hk-amt-table"
            dynamicClass="fill-grid DataGrid-Table hk-exp-table two-rows-with-tab"
            rowHeight={25}
            PerPage={PerPage}
            PageNo={PageNo}
            TotalPages={TotalPages}
            Counts={totalCounts}
            handlePageClick={handlePageClick}
            PreviousPage={PreviousPage}
            handleFingByCreteria={handleFingByCreteria}
            NextPage={NextPage}
            Key={4310}
            Name={"Write Off"}
            // TableName={'WRITEOFFREPORT'}
            // hidePagination={true}
            isLoading={isLoading}
            hideColClass='hide'
            handleSelectData={handleSelectData}
            TableName={'WRITEOFFREPORT'}
            LoadData={() => LoadData(searchParam)}
            ClearSearch={handleClear}
          // colPopup='realtime-hide-popup'
          />
        </div>
      ) : null}
    </>
  )
}
const mapStateToProps = (state) => {
  return {
    Settings: state.SettingsReducer,
  }
}
export default connect(mapStateToProps)(WriteOffReport)